import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import { Button, AlertService, LoadingSmall, Theme as theme } from '@spoiler-alert/ui-library';
import { fetchWithToken } from '../../services/fetch-with-token';
import AppSettings from '../../app-settings';

const serverUrl = AppSettings.GRAPHQL_SERVER_URL;
const stressTestUrl = `${serverUrl}stress-test/recalculation`;

const useStyles = createUseStyles({
  results: {
    marginTop: 16,
    padding: 12,
    border: `1px ${theme.grey80} solid`,
    borderRadius: 2,
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '6px 16px',
  },
  label: {
    color: theme.grey40,
    fontSize: 13,
  },
  value: {
    fontWeight: 600,
    fontSize: 13,
  },
  colorTotal: { color: theme.textColorPrimary },
  colorSuccess: { color: theme.primaryColor },
  colorNeutral: { color: theme.textColorPrimary },
  colorError: { color: theme.errorColor },
  loaderWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginTop: 16,
    fontSize: 13,
    color: theme.grey40,
  },
  loaderIcon: {
    width: 30,
    display: 'inline-block',
  },
});

const StressTestWidget = () => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);

  const handleStressTest = async () => {
    setLoading(true);
    setResults(null);
    try {
      const resp = await fetchWithToken(stressTestUrl, { method: 'GET' });
      if (resp.status !== 200) throw new Error('Stress test failed');
      const data = await resp.json();
      setResults(data);
    } catch {
      AlertService.alert({ type: 'warning', message: 'Recalculations stress test failed.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4>Recalculations Stress Test</h4>
      <Button onClick={handleStressTest} disabled={loading}>
        Run Stress Test
      </Button>
      {loading && (
        <div className={classes.loaderWrap}>
          <span className={classes.loaderIcon}>
            <LoadingSmall />
          </span>
          Running stress test...
        </div>
      )}
      {results && (
        <div className={classes.results}>
          <span className={classes.label}>Total</span>
          <span className={`${classes.value} ${classes.colorTotal}`}>{results.total}</span>
          <span className={classes.label}>Triggered</span>
          <span className={`${classes.value} ${classes.colorSuccess}`}>{results.triggered}</span>
          <span className={classes.label}>Skipped (no offer listings)</span>
          <span className={`${classes.value} ${classes.colorNeutral}`}>{results.skipped}</span>
          <span className={classes.label}>Failed</span>
          <span className={`${classes.value} ${classes.colorError}`}>{results.failed}</span>
        </div>
      )}
    </div>
  );
};

export default StressTestWidget;
